// File: client/src/components/dashboard/Dashboard.js
import React from 'react';
import { useAuth } from '../../context/auth/AuthProvider';
import ContaDashboard from './ContaDashboard';
import MatrizDashboard from './MatrizDashboard';
import { Spinner } from 'react-bootstrap';

const Dashboard = () => {
    const { user, isLoading, scope } = useAuth();

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <Spinner animation="border" />
            </div>
        );
    }

    if (!user) return null;

    // ⚠️ Antes comparava user.role.name === 'matriz_admin' — qualquer papel
    // de matriz com nome diferente (ex: super_admin, ou um papel matriz
    // customizado) caía silenciosamente no ContaDashboard, que dispara
    // useContaDashboard() sem accountId (matriz não tem conta própria) e
    // trava 30s até o timeout do axios. scope já é a fonte de verdade usada
    // no resto do app pra distinguir matriz/franquia/conta.
    if (scope === 'matriz') {
        return <MatrizDashboard />;
    }

    return <ContaDashboard />;
};

export default Dashboard;